export default "__VITE_ASSET__CraD15r9__"